import { FETCH_CREDENTIALS } from './types';
import api from '../apis/api';
import getMessageFromApiError from '../util/getMessageFromApiError';
import { setErrorMessage } from './errorMessage';

export const fetchCredentials = (project_uuid, id) => async (dispatch) => {
  try {
    if (!id) {
      if (!project_uuid) {
        throw new Error('project_uuid is required when id is not provided');
      }
      id = project_uuid;
    }
    const res = await api.get(`/project/${id}/credentials/`);
    dispatch({
      type: FETCH_CREDENTIALS,
      payload: res.data,
    });
  } catch (error) {
    const message = getMessageFromApiError(error);
    dispatch(setErrorMessage(message));
    throw new Error(`API Error - ${message}`);
  }
};

export const removeCredential =
  (project_uuid, id, type) => async (dispatch) => {
    try {
      await api.delete(`/project/${id}/credentials/${type}`);
      dispatch(fetchCredentials(project_uuid, id));
    } catch (error) {
      const message = getMessageFromApiError(error);
      dispatch(setErrorMessage(message));
      throw new Error(`API Error - ${message}`);
    }
  };
export const putCredential = (project_uuid, id, values) => async (dispatch) => {
  try {
    await api.put(`/project/${id}/credentials/${values.type}`, values);
    dispatch(fetchCredentials(project_uuid, id));
  } catch (error) {
    const message = getMessageFromApiError(error);
    dispatch(setErrorMessage(message));
    throw new Error(`API Error - ${message}`);
  }
};

export const getCredentials = async (id) => {
  try {
    const res = await api.get(`/project/${id}/credentials/`);
    return res.data;
  } catch (error) {
    const message = getMessageFromApiError(error);
    throw new Error(`API Error - ${message}`);
  }
};
